import { useEffect, useState } from "react";
import t, { useToasterStore } from "react-hot-toast";

interface IToastProps {
  limit?: number;
}

const useToast = (props?: IToastProps) => {
  const { toasts } = useToasterStore();

  const [toastLimit, setToastLimit] = useState<number>(props?.limit || 3);

  useEffect(() => {
    toasts
      .filter((tt) => tt.visible)
      .filter((_, i) => i >= toastLimit)
      .forEach((tt) => t.dismiss(tt.id));
  }, [toasts]);

  const toast = {
    ...t,
    setLimit: (l: number) => {
      if (l !== toastLimit) {
        setToastLimit(l);
      }
    },
  };

  return { toast };
};

export default useToast;
